import { useState, useEffect } from "react"
import cx from "classnames"
import p from "./../styles/popup.module.css"

/*
export default function Popup() {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        // Comprueba si el popup ya se mostró en esta sesión
        const hasPopupBeenShown = sessionStorage.getItem('popupShown');

        if (!hasPopupBeenShown) {
            // Si no se ha mostrado, lo mostramos
            setShowPopup(true);
            // Y marcamos que ya se mostró para esta sesión
            sessionStorage.setItem('popupShown', 'true');
        }
        
        const handleClosePopup = () => {
            setShowPopup(false);
        };
        
        if (!showPopup) {
            return null; // No renderiza nada si el popup no debe mostrarse
        }
    }
    ), [];

    return (
        <>
            <div className={ cx(p.popup_display) }>
                <div className={ cx(p.popup_content) }>Holaaaaaaa</div>
            </div>
        </>
    )
}
    */

const Popup = () => {
    const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const popupShownInCurrentSessionKey = 'popupShownInCurrentSession';
    const refreshCountSinceLastPopupKey = 'refreshCountSinceLastPopup';

    const popupShownInCurrentSession = sessionStorage.getItem(popupShownInCurrentSessionKey);
    let refreshCountSinceLastPopup = parseInt(localStorage.getItem(refreshCountSinceLastPopupKey) || '0', 10);

    let shouldShow = false;

    if (!popupShownInCurrentSession) {
      // Caso 1: Primera vez que se carga la página en una nueva sesión
      shouldShow = true;
      sessionStorage.setItem(popupShownInCurrentSessionKey, 'true'); // Marca que ya se mostró en esta sesión
      localStorage.setItem(refreshCountSinceLastPopupKey, '0'); // Reinicia el contador de refrescos
    } else {
      // Caso 2: La página ya se cargó en esta sesión (es un refresh o una nueva pestaña en la misma sesión)
      refreshCountSinceLastPopup++; // Incrementa el contador de refrescos
      localStorage.setItem(refreshCountSinceLastPopupKey, refreshCountSinceLastPopup.toString());

      if (refreshCountSinceLastPopup >= 3) {
        // Si se han hecho 3 o más refrescos desde la última vez que apareció el popup
        shouldShow = true;
        localStorage.setItem(refreshCountSinceLastPopupKey, '0'); // Reinicia el contador
        // Opcional: Si quieres que el popup vuelva a aparecer en la *siguiente* nueva sesión después de este ciclo de 3 refrescos,
        // podrías limpiar sessionStorage aquí: sessionStorage.removeItem(popupShownInCurrentSessionKey);
        // Sin embargo, la lógica actual ya lo maneja bien para la siguiente sesión.
      }
    }

    if (shouldShow) {
      setShowPopup(true);
      // Evitar scroll cuando el popup está abierto
      document.body.style.overflow = 'hidden';
    }

    // Limpieza al desmontar el componente o cuando showPopup cambia
    return () => {
      // Asegúrate de restaurar el scroll si el popup está abierto cuando el componente se desmonta
      if (document.body.style.overflow === 'hidden') {
        document.body.style.overflow = '';
      }
    };
  }, []); // Se ejecuta una vez al montar el componente

  const handleClosePopup = () => {
    setShowPopup(false);
    // Restaurar el scroll cuando el popup se cierra
    document.body.style.overflow = '';
  };

  if (!showPopup) {
    return null; // No renderiza nada si el popup no debe mostrarse
  }
  
    return (
        <>
            <div className={ cx(p.popup_display) }>
                <div className={ cx(p.popup_content) }>
                    {/*
                    <div className={ cx(p.popup_content_img) }>
                        <img src="/images/popup_otono.png" alt="Popup" />
                    </div>
                    <div className={ cx(p.popup_content_des) }>
                        <img className={ cx(p.popup_content_des_bg) } src="/images/home/popup_bg.svg" alt="Background" title="Background"/>
                        <div className={ cx(p.popup_content_txt_con) }>
                            <h1 className={ cx(p.popup_content__t1) }>15%</h1>
                            <h2 className={ cx(p.popup_content__t2) }>DE DESCUENTO</h2>
                            <h2 className={ cx(p.popup_content__t2_1) }>+</h2>
                            <h2 className={ cx(p.popup_content__t2_2) }>1 NIÑO GRATIS</h2>
                        </div>
                        <div className={ cx(p.popup_content__t3) }>EN BOLETO DIGITAL<br/>COMPRANDO EN SITIO WEB</div>
                        <a href="https://tickets.granacuario.com/" target="_blank" className={ cx(p.popup_content__t4) }>granacuario.com</a>
                        <div className={ cx(p.popup_content__t5) }>*SUJETO A DISPONIBILIDAD</div>
                    </div>
                    */}
                    <div className={ cx(p.popup_content_solo_img) }>
                        <picture>
                            
                            <source srcSet="/images/popup_abril_mobile.webp" media="(max-width: 599px)"/>
                            <source srcSet="/images/popup_abril_mobile.png" media="(max-width: 599px)"/>
                            <img src="/images/popup_abril.png" srcSet="/images/popup_abril.webp" alt="Popup" />
                        </picture>
                    </div>
                    <button className={ cx(p.popup_close, "close-popup-btn")} onClick={handleClosePopup}>&times;</button>
                </div>
            </div>
        </>
    );
  };
  
  export default Popup;